import { useEffect, useRef } from "react";

/**
 * Bulk Edit opens itself the moment a selection starts (0 -> 1+, tracked via
 * a ref so re-checking more boxes afterward doesn't keep forcing it back
 * open if the admin manually closed it), and closes itself if the selection
 * drops back to zero (Clear Selection, or unchecking the last remaining
 * record) rather than sitting open with nothing to act on.
 *
 * Shared by every *Table.js page that wires up Bulk Edit (Library, Archive,
 * ...) — each page still owns its own `activeSidePanel` state; this hook
 * only owns the open/close transition logic driven by selection count.
 */
export function useAutoOpenBulkEditPanel(selectionCount, activeSidePanel, setActiveSidePanel) {
  const prevSelectionCountRef = useRef(0);
  useEffect(() => {
    const prevCount = prevSelectionCountRef.current;
    if (prevCount === 0 && selectionCount > 0) {
      setActiveSidePanel("bulkEdit");
    } else if (selectionCount === 0 && activeSidePanel === "bulkEdit") {
      setActiveSidePanel(null);
    }
    prevSelectionCountRef.current = selectionCount;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectionCount]);
}
